import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16.497 11.251a2 2 0 0 0-2.963 1.579q-.531 6.205-.534 11.704-.003 5.472.525 11.57a2 2 0 0 0 2.962 1.576l21.864-12.12a1.25 1.25 0 0 0 0-2.187zm.97-1.749L39.32 21.624a3.25 3.25 0 0 1 0 5.685l-21.864 12.12a4 4 0 0 1-5.924-3.152q-.537-6.182-.533-11.745.003-5.586.541-11.872a4 4 0 0 1 5.926-3.158",
      clipRule: "evenodd"
    }
  )
);
var SvgPlayOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PlayOutlined_default = SvgPlayOutlined;

export { PlayOutlined_default as default };
